export const buildRequirementPayload = (formData, companyRef) => {
  const {
    nombre,
    documento,
    celular,
    cargo,
    correo,
    ciudad,
    tipoPrueba,
    cliente,
    centro,
    tipoDocumento
  } = formData;

  const clean = (v) => (v !== null && v !== undefined && v !== '' ? v : undefined);

  return {
    candidate: {
      nit: clean(documento),
      identificationType: clean(tipoDocumento),
      name: clean(nombre),
      phoneNumber: clean(celular),
      city: clean(ciudad),
      companyName: clean(cliente),
      position: clean(cargo),
      email: clean(correo)
    },
    test: {
      testType: clean(tipoPrueba),
    },
    companyId: clean(companyRef),
    requirement: {
      position: clean(cargo),
      costCenter: clean(centro)
    }
  };
};